import React from "react";
import { List, ListItemButton } from "@mui/material";
import { MuiBox, MuiTypography } from "components/atoms";
import { useLocation, useNavigate } from "react-router-dom";
import { settingsList } from "utils/menulist";
import { useTranslation } from "react-i18next";

//SVGs

import LeftArrow from "assets/images/svg-icons/chevron-left.svg";

//sidebar content for the settings layout

const SettingsSidebarContent = ({ onMenuClick }) => {
  const { t } = useTranslation();

  const location = useLocation();

  const navigate = useNavigate();

  return (
    <MuiBox sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
      <MuiBox
        onClick={() => navigate("/drive/home")}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          cursor: "pointer",
          borderRadius: "8px",
          height: "48px",
          ":hover": {
            backgroundColor: "background.white",
          },
        }}
      >
        <MuiBox sx={{ height: "20px", width: "20px" }}>
          <img src={LeftArrow} className="img-full" alt="" />
        </MuiBox>
        <MuiTypography fontWeight="600" variant="16" color="text.darkBlack">
          {t("setting.settings")}
        </MuiTypography>
      </MuiBox>
      <List sx={{ display: "flex", flexDirection: "column", gap: "8px", p: 0 }}>
        {settingsList({ t }).map((item) => {
          const isActive = location.pathname.startsWith(
            `/drive/settings/${item.slug}`,
          );

          return (
            <ListItemButton
              key={item.slug}
              onClick={() => { navigate(`/drive/settings/${item.slug}`); onMenuClick?.(); }}
              sx={{
                p: "8px 12px",
                borderRadius: "8px",
                color: isActive ? "text.white" : "text.lightgray",
                bgcolor: isActive ? "background.blue700" : "transparent",
                "&:hover": {
                  bgcolor: isActive ? "background.blue600" : "background.white",
                },
              }}
            >
              {/* <ListItemText primary={item.label} /> */}
              <MuiTypography variant="14" >
                {item.label}
              </MuiTypography>
            </ListItemButton>
          );
        })}
      </List>
    </MuiBox>
  );
};

export default SettingsSidebarContent;
